module.exports = __webpack_public_path__ + "static/media/elegant-1.ee237295.png";